var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-form-model",
    {
      ref: "customMenuForm",
      staticClass: "custom-menu-form",
      attrs: { layout: "vertical", model: _vm.form, rules: _vm.rules },
      on: { submit: _vm.handleSubmit },
    },
    [
      _c(
        "a-form-model-item",
        { attrs: { prop: "customMenuName" } },
        [
          _c(
            "a-row",
            { attrs: { type: "flex", gutter: 24 } },
            [
              _c("a-col", { attrs: { required: "" } }, [
                _c(
                  "span",
                  {
                    staticClass: "system-menu-form__menus-name",
                    staticStyle: { "line-height": "32px" },
                  },
                  [_vm._v(_vm._s(_vm.$t("form-modal.customMenuName")) + "：")]
                ),
              ]),
              _c(
                "a-col",
                { attrs: { flex: "auto" } },
                [
                  _c("a-input", {
                    staticStyle: { width: "320px" },
                    attrs: {
                      placeholder: _vm.i18nRender(
                        "form-modal.menuname.placeholder"
                      ),
                    },
                    model: {
                      value: _vm.form.customMenuName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "customMenuName", $$v)
                      },
                      expression: "form.customMenuName",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "a-form-model-item",
        { attrs: { prop: "menuIds" } },
        [
          _c(
            "a-checkbox-group",
            {
              model: {
                value: _vm.form.menuIds,
                callback: function ($$v) {
                  _vm.$set(_vm.form, "menuIds", $$v)
                },
                expression: "form.menuIds",
              },
            },
            [
              _vm._l(_vm.menusOptions, function (menu, index) {
                return [
                  index ? _c("a-divider", { key: `_${menu.key}` }) : _vm._e(),
                  _c(
                    "a-row",
                    { key: menu.key, attrs: { gutter: 24 } },
                    [
                      _c("a-col", { attrs: { span: "4" } }, [
                        _c(
                          "span",
                          { staticClass: "system-menu-form__menus-name" },
                          [
                            _vm._v(
                              _vm._s(menu.menuName[_vm.currentLang] || menu.tab)
                            ),
                          ]
                        ),
                      ]),
                      _c(
                        "a-col",
                        { attrs: { span: "20" } },
                        _vm._l(menu.options, function (pane) {
                          return _c(
                            "a-checkbox",
                            {
                              key: pane.key,
                              style: { marginBottom: "4px" },
                              attrs: {
                                name: "menuIds",
                                value: pane.menuId,
                                disabled:
                                  _vm.form.menuIds.length >= 15 &&
                                  _vm.form.menuIds.indexOf(pane.menuId) === -1,
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: {
                                    title:
                                      pane.menuName[_vm.currentLang] ||
                                      pane.tab,
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      pane.menuName[_vm.currentLang] || pane.tab
                                    )
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "a-form-model-item",
        { staticStyle: { "margin-bottom": "0" }, attrs: { prop: "remark" } },
        [
          _c("a-input", {
            attrs: {
              type: "textarea",
              placeholder: _vm.i18nRender("form-modal.remark.placeholder"),
            },
            model: {
              value: _vm.form.remark,
              callback: function ($$v) {
                _vm.$set(_vm.form, "remark", $$v)
              },
              expression: "form.remark",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }